import request from '../utils/request'

// export const baseUrl = 'http://localhost:8080/image/';
export const baseUrl = 'https://www.huijianzhilian.com/image/';
export const uploadeImage = 'https://www.huijianzhilian.com/uploadeImage/';
export const addImages= async (data) => {
  return request({
    url: "/admin/upload",
    method: 'post',
    data: data,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}